import { inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from "@angular/router";
import { ErrorCodes } from "src/app/modules/maintenance/error-codes";
import {
  StatusPageService,
  StatusPageServiceStatusIndicator
} from "src/app/services/status-page.service";
import { maintenance } from "src/app/support/maintenance";

@Injectable()
export class StatusPageGuard implements CanActivate {
  readonly #router = inject(Router);
  readonly #statusPageService = inject(StatusPageService);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return true;

    /*

    TODO: verificare lo stato dei componenti core ed in caso reindirizzre l'utente

    try {
      const currentStatus = await this.#statusPageService.load();

      switch (currentStatus.status.indicator) {
        case StatusPageServiceStatusIndicator.MAJOR: {
          maintenance(this.#router, {
            code: ErrorCodes.ERR_017
          });
          return false;
        }
        case StatusPageServiceStatusIndicator.MINOR:
        case StatusPageServiceStatusIndicator.NONE: {
          return true;
        }
      }

      return true;
    } catch (ex) {
      return true;
    }
      */
  }
}
